import useIsMobileBrowser from '@aorg/hooks/common/useIsMobileBrowser';
import useOpenApp from '@aorg/hooks/common/useOpenApp';
import { Transition } from '@headlessui/react';
import { ArrowRightCircleIcon } from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import CommingSoonDialog from './CommingSoonDialog';

function OpenAppSheetMini() {
  const { isMobile, platform } = useIsMobileBrowser();
  const openApp = useOpenApp();
  const [isCommingSoon, setIsCommingSoon] = useState(false);

  const [showMobilePopup, setShowMobilePopup] = useState(false);

  useEffect(() => {
    if (isMobile) {
      setTimeout(() => {
        setShowMobilePopup(true);
      }, 1000);
    }
  }, [isMobile]);

  return (
    <>
      <CommingSoonDialog
        isOpen={isCommingSoon}
        onClose={() => setIsCommingSoon(false)}
      />
      <Transition
        as={'div'}
        show={showMobilePopup}
        className="fixed bottom-0 w-full transition-all duration-300 transform"
        enterFrom="translate-y-full"
        enterTo="translate-y-0"
        leaveFrom="translate-y-0"
        leaveTo="translate-y-full"
      >
        <div className="bg-black px-4 py-4 text-white flex justify-between items-center">
          <div className="flex items-center gap-4">
            <div
              className="bg-transparent text-white rounded-full w-6 h-6 p-1  flex justify-center items-center border border-solid border-primary"
              onClick={() => setShowMobilePopup(false)}
            >
              <MdClose />
            </div>
            <span className="text-white flex-1">Open the Athletes.org App</span>
            <div
              className="text-white rounded-full align-left"
              onClick={() => {
                openApp();
              }}
            >
              <ArrowRightCircleIcon className="w-6 h-6" />
            </div>
          </div>
        </div>
      </Transition>
    </>
  );
}

export default OpenAppSheetMini;
